import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Plus } from "lucide-react";

const FAQ = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-white"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-brand" />
            <span className="text-[11px] tracking-[0.25em] font-bold text-brand">
              {t.faq.eyebrow}
            </span>
            <span className="w-10 h-px bg-brand" />
          </div>
          <h2
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight"
            data-testid="faq-title"
          >
            {t.faq.title}
          </h2>
        </div>

        <div className="divide-y divide-brand-line/70 border-y border-brand-line/70">
          {t.faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className="py-2"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-start justify-between gap-6 py-5 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="font-display text-lg sm:text-xl font-medium text-brand-ink tracking-tight pr-4">
                    {item.q}
                  </span>
                  <span
                    className={`flex-shrink-0 w-9 h-9 rounded-full border border-brand-line flex items-center justify-center transition-all duration-300 ${
                      isOpen
                        ? "bg-brand text-white border-brand rotate-45"
                        : "text-brand group-hover:bg-brand group-hover:text-white group-hover:border-brand"
                    }`}
                  >
                    <Plus size={16} strokeWidth={2} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-brand-muted leading-relaxed max-w-3xl pr-14">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
